const albumData = [
    {
        name: "test album",
        artist: "emma trzupek",
        release: "02/06/2023",
        library: "02/06/2023",
        songcount: 4,
        songs: "song one@@doo bee doo bee@@third song@@aw last one"
    },
    {
        name: "dreamland",
        artist: "glass animals",
        release: "08/07/2020",
        library: "12/24/2020",
        songcount: 12,
        songs: "dreamland@@tangerine@@hot sugar@@space ghost coast to coast@@tokyo drifting@@melon and the coconut@@your love (deja vu)@@waterfalls coming out your mouth@@it's all so incredibly loud@@domestic bliss@@heat waves@@helium"
    },
    {
        name: "infinitely ordinary",
        artist: "the wrecks",
        release: "04/30/2020",
        library: "04/30/2020",
        songcount: 8,
        songs: "freaking out@@feels so nice@@out of style@@four@@we all get lonely@@this life i have@@infinitely ordinary"
    },
    {
        name: "dusk",
        artist: "mxmtoon",
        release: "10/01/2020",
        library: "10/01/2020",
        songcount: 7,
        songs: "bon iver@@ok on your own@@myrtle ave.@@wallflower@@asking for a friend@@show and tell@@first",
    },
    {
        name: "sunset season",
        artist: "conan gray",
        release: "11/16/2018",
        library: "06/04/2020",
        songcount: 5,
        songs: "idle town@@generation why@@crush culture@@greek god@@lookalike"
    },
    {
        name: "ycgma",
        artist: "wilbur",
        release: "06/25/2020",
        library: "11/23/2020",
        songcount: 7,
        songs: "jubilee line@@saline solution@@since i saw vienna@@losing face@@your sister was right@@la jolla@@i'm sorry boris"
    },
    {
        name: "pebble brain",
        artist: "lovejoy",
        release: "10/14/2021",
        library: "10/14/2021",
        songcount: 7,
        songs: "oh yeah, you gonna cry@@model buses@@concrete@@perfume@@you'll understand when you're older@@the fall@@it's all futile! it's all pointless!"
    },
    {
        name: "harry's house",
        artist: "harry styles",
        release: "05/20/2022",
        library: "05/20/2022",
        songcount: 13,
        songs: "music for a sushi restaurant@@late night talking@@grapejuice@@as it was@@daylight@@little freak@@matilda@@cinema@@daydreaming@@keep driving@@satellite@@boyfriends@@love of my life"
    },
    {
        name: "oddinary",
        artist: "stray kids",
        release: "03/18/2022",
        library: "04/14/2022",
        songcount: 7,
        songs: "venom@@maniac@@charmer@@freeze@@lonely st.@@waiting for us@@muddy water"
    },
    {
        name: "wasteland, baby",
        artist: "hozier",
        release: "03/01/2019",
        library: "02/28/2022",
        songcount: 14,
        songs: "nina cried power@@almost (sweet music)@@movement@@no plan@@nobody@@to noise making (sing)@@as it was@@shrike@@talk@@be@@dinner & diatribes@@would that i@@sunlight@@wasteland, baby"
    },
    {
        name: "ok orchestra",
        artist: "ajr",
        release: "03/26/2021",
        library: "10/21/2021",
        songcount: 13,
        songs: "ok overture@@bummerland@@3 o'clock things@@my play@@joe@@adventure is out there@@bang!@@the trick@@ordianaryish people@@humpty dumpty@@world's smallest violin@@way less sad@@christmas in june1"
    },
    {
        name: "carrie & lowell",
        artist: "sufjan stevens",
        release: "03/31/2015",
        library: "12/31/2022",
        songcount: 11,
        songs: "death with dignity@@should have known better@@all of me wants all of you@@drawn to the blood@@eugene@@fourth of july@@the only thing@@carie & lowell@@john my beloved@@ no shade in the shadow of the cross@@blue bucket of gold"
    },
    {
        name: "now, not yet",
        artist: "half • alive",
        release: "08/09/2019",
        library: "07/06/2021",
        songcount: 11,
        songs: "ok ok?@@runaway@@maybe@@still feel.@@trust@@arrow@@pure gold@@ice cold.@@rest@@breakfast@@creature"
    },
    {
        name: "happier than ever",
        artist: "billie eilish",
        release: "07/30/2021",
        library: "07/30/2021",
        songcount: 16,
        songs: "getting older@@i didn't change my number@@billie bossa nova@@my future@@oxytocin@@goldwing@@lost cause@@halley's comet@@not my responsibility@@overheated@@everybody dies@@your power@@nda@@therefore i am@@happier than ever@@male fantasy"
    },
    {
        name: "magic man",
        artist: "jackson wang",
        release: "09/09/2022",
        library: "12/18/2022",
        songcount: 10,
        songs: "blow@@cruel@@champagne cool@@go ghost@@drive it like you stole it@@come alive@@just like magic@@all the way@@dopamine@@blue"
    }
]
//vv that's needed because it wants the objects assigned to a variable before exporting. the comment overrides this
// eslint-disable-next-line
export default {state: 0, audio: new Audio(), song: "no song playing", artist: "no current artist", playing: false, looping: true, albumData};